import { Box, VStack } from '@genial/components';
import React from 'react';
import { FlatList } from 'react-native';

import { TransferStatusHistoryItem } from '../../../../store/customerDetail/SecuritiesTransfer/types';

import { TimelineItemLoading, TimelineItemMemo } from './components/TimelineItem';

interface StatusTimelineProps {
  items: TransferStatusHistoryItem[];
}

export const ItemSeparator: React.FC = () => {
  return (
    <Box
      height="stack.xxs"
      mb="stack.nano"
      ml="11px"
      borderStyle="dashed"
      borderLeftWidth="1px"
      borderColor="neutral.lightest"
    />
  );
};

export const StatusTimeline: React.FC<StatusTimelineProps> = ({ items }) => {
  return (
    <VStack>
      <FlatList
        data={items}
        keyExtractor={(item) => item.id}
        ItemSeparatorComponent={ItemSeparator}
        renderItem={({ item }) => <TimelineItemMemo {...item} />}
        showsVerticalScrollIndicator={false}
      />
    </VStack>
  );
};

interface StatusTimelineLoadingProps {
  rowsCount?: number;
}

export const StatusTimelineLoading: React.FC<StatusTimelineLoadingProps> = ({ rowsCount = 3 }) => {
  const rows = Array.from({ length: rowsCount }, (_, i) => i);

  return (
    <VStack>
      <FlatList
        data={rows}
        keyExtractor={(item) => String(item)}
        ItemSeparatorComponent={ItemSeparator}
        renderItem={() => <TimelineItemLoading />}
        showsVerticalScrollIndicator={false}
      />
    </VStack>
  );
};
